import { observer } from "owa-mobx-react";
import type { MailListItemWrapperProps } from "owa-mail-list-item-shared";
import { getStore as getListViewStore } from "owa-mail-list-store";
import { useComputedValue } from "owa-react-hooks/lib/useComputed";
import { getIsChecked } from "owa-mail-list-item-shared";
import { MailListItem } from "owa-mail-list-item";
import { mailListItemTouchBehavior } from "owa-mail-list-swipe";
import { getBigHoverAction } from "owa-surface-actions/lib/utils/getBigHoverAction";
import { getHoverSurfaceAction, getStore as getHoverSurfaceActionStore, } from "owa-surface-actions-option";
import getUnreadItemClass from "../selectors/getUnreadItemClass";
import { BigHoverAction } from "../lazyFunctions";
import { shouldShowBigHoverAction } from "./BigHoverAction/utils/shouldShowBigHoverAction";
import { getDensityModeString } from "owa-fabric-theme";
import classnames from "owa-classnames";
import { showDeleteOnHover, mailListItem, unreadMailListItem, unreadMailListItemDarker, mailListItemRightPadding, mailListItemRPRightPadding, } from "owa-mail-listitem-styles/lib/scss/ListViewItemCommonStyles.scss";
import { BigHoverActionPlaceholder } from "owa-mail-list-view-bighoveraction";
import { isReadingPanePositionRight } from "owa-mail-layout";
import type { ComponentClass, FunctionComponent } from "react";

export const MailListItemWithoutTouchBehavior: FunctionComponent<MailListItemWrapperProps> = observer(function (props: MailListItemWrapperProps) {
    const { mailListItemDataProps, mailListTableProps, isFirstLevelExpanded, isSecondLevelExpanded, isLoadingSecondLevelExpansion, styleSelectorAsPerUserSettings, renderMinimum, } = props;
    
    const { tableViewId, isSingleLine } = mailListTableProps;
    
    const { canDelete, canArchive, isInArchiveFolder, isInOutboxFolder, lastDeliveryTimestamp, rowKey, unreadCount, } = mailListItemDataProps;
    
    const tableView = getListViewStore().tableViews.get(tableViewId);
    
    const isChecked = useComputedValue(() => getIsChecked(tableView, rowKey, lastDeliveryTimestamp), [tableViewId, rowKey, lastDeliveryTimestamp]);
    
    const unreadItemClass = getUnreadItemClass(mailListItemDataProps, mailListTableProps, isChecked, unreadMailListItem, unreadMailListItemDarker);
    
    const bigHoverAction = !isSingleLine &&
        getBigHoverAction(getHoverSurfaceActionStore().hoverSurfaceActions ?? getHoverSurfaceAction());
    const showBigHoverAction = !isSingleLine &&
        bigHoverAction &&
        shouldShowBigHoverAction(bigHoverAction, canDelete, canArchive, isInArchiveFolder, isInOutboxFolder);
    
    // Outer container CSS classes that are shared between 3 column and single line views
    const mailListItemOuterContainerClasses = classnames(mailListItem, isSingleLine
        ? isReadingPanePositionRight()
            ? mailListItemRPRightPadding
            : mailListItemRightPadding
        : undefined, showBigHoverAction && showDeleteOnHover, unreadCount > 0 && unreadItemClass);
    
    return (<div className={mailListItemOuterContainerClasses} tabIndex={-1}>
                <MailListItem mailListTableProps={mailListTableProps} mailListItemDataProps={mailListItemDataProps} styleSelectorAsPerUserSettings={styleSelectorAsPerUserSettings} isFirstLevelExpanded={isFirstLevelExpanded} isSecondLevelExpanded={isSecondLevelExpanded} isLoadingSecondLevelExpansion={isLoadingSecondLevelExpansion} renderMinimum={renderMinimum}/>
                {showBigHoverAction &&
            (renderMinimum ? (<BigHoverActionPlaceholder />) : (<BigHoverAction rowKey={rowKey} tableViewId={tableViewId} isSingleLine={isSingleLine} isItemPart={false} bigHoverAction={bigHoverAction} densityModeString={getDensityModeString()}/>))}
            </div>);
}, "MailListItemWrapper");

export const MailListItemWithTouchBehavior: ComponentClass<MailListItemWrapperProps, any> = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function mailListItemTouchBehavior called at module scope is not allowed. This may cause unwanted side effects. */
mailListItemTouchBehavior(MailListItemWithoutTouchBehavior);
